import type { Bounds } from './queries';

// [west, south, east, north] of a WGS84 [lng, lat] line, or null for an empty line.
export const lineBounds = (line: [number, number][]): Bounds | null => {
    if (line.length === 0) {
        return null;
    }
    const lngs = line.map(([lng]) => lng);
    const lats = line.map(([, lat]) => lat);

    return [Math.min(...lngs), Math.min(...lats), Math.max(...lngs), Math.max(...lats)];
};
